<template>
  <div>
    <iframe
      width="100%"
      height="1080px"
      :src="iframeUrl"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeUrl: "",
    };
  },
  created() {
    this.iframeUrl = JSON.parse(
      decodeURIComponent(location.hash.split("=")[1])
    ).iframeUrl;
  },
};
</script>
